import { render, staticRenderFns } from "./complaint-form.vue?vue&type=template&id=4bf97efe&scoped=true"
import script from "./complaint-form.vue?vue&type=script&lang=js"
export * from "./complaint-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf97efe",
  null
  
)

export default component.exports